import { useMutation } from '@tanstack/react-query'
import { notificationMarkRead } from '../index'

const useNotificationMarkRead = () =>
  useMutation({
    mutationFn: notificationMarkRead,
  })

export default useNotificationMarkRead
